import type { StyleRule } from '@archipro-design/aria';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import { TextTypeEnum } from 'generated/graphql';
import type {
    PageBuilderModuleMetaProps,
    TextColumnProps,
} from '@modules/page-builder/types';
import RichTextDisplay from '../../common/rich-text/display/RichTextDisplay';
import * as S from './SingleParagraphModule.style';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';

interface SingleParagraphModuleProps extends PageBuilderModuleMetaProps {
    column: TextColumnProps;
}

const classNameMapping: Record<TextTypeEnum, StyleRule> = {
    [TextTypeEnum.Paragraph]: S.SingleParagraphContainer,
    [TextTypeEnum.H3]: S.H3Container,
    [TextTypeEnum.Quote]: S.QuoteContainer,
};

const SingleParagraphModule = ({
    column,
    meta,
}: SingleParagraphModuleProps) => {
    const textType = column.textType ?? TextTypeEnum.Paragraph;

    const { css } = useStyles({ textType });
    const { mobile: isMobile } = useAppDisplayModeContext();
    const clickProxy = useWebsiteTrackingProxy({
        professionalID: meta?.professional?.id,
        professionalTitle: meta?.professional?.title,
        itemType: meta?.itemType,
    });

    if (isMobile && !column.content) {
        return null;
    }

    return (
        <div className={css(classNameMapping[textType])} onClick={clickProxy}>
            <RichTextDisplay
                textType={textType}
                contentHTML={column.contentHTML}
            />
        </div>
    );
};

export default SingleParagraphModule;
